/*
 * Copyright (C) 2017 BossieTech Co.,Ltd. All Rights Reserved.
 * Creator  :   Alfred
 * Date     :   2018/10/22
 */
import request from '@/utils/request'
import qs from 'qs'

// 获取目标模板Id下的表单列表,支持分页，排序，过滤，用户权限会影响内容输出
export function getFormTableData(params) {
  return request({
    url: `/templates/${params.templateId}/forms`,
    method: 'get',
    params
  })
}
// 获取模板字段绑定的excel公式
export function getExcelFormula(templateId) {
  return request({
    url: `/templates/${templateId}/excelformula`,
    method: 'get'
  })
}
// 获取模板的数据表信息(表头信息) childType=3,pageSize=100
export function getFormTableHeader(params) {
  return request({
    url: `/templates/${params.templateId}/datasheets`,
    method: 'get',
    params
  })
}
// 获取对应模板下单据的数据
export function getFormData(templateId, formId) {
  return request({
    url: `/templates/${templateId}/forms/${formId}`,
    method: 'get'
  })
}
// 创建新单据
export function addNewForm(templateId, recordId, data, fillScheme) {
  data.nonce = recordId
  const params = fillScheme ? { fillScheme } : {}
  return request({
    url: `/templates/${templateId}/forms`,
    method: 'post',
    data,
    params
  })
}
// 修改老单据
export function modifyForm(templateId, recordId, data) {
  return request({
    url: `/templates/${templateId}/forms/${recordId}`,
    method: 'put',
    data
  })
}
// 创建获取ticket
export function getReportTicket(recordId) {
  return request({
    url: `/credentials`,
    method: 'post',
    data: {
      type: 'report',
      target: recordId
    }
  })
}

// 释放ticket
export function dropReportTicket(credentialId) {
  if (credentialId) {
    return request({
      url: `/credentials/${credentialId}`,
      method: 'delete'
    })
  }
}

// 获取模板的额外属性
export function GetTemplateAttribute(templateId) {
  return request({
    url: `/templates/${templateId}/attribute`,
    method: 'get'
  })
}

// 获取模板的高级权限属性
// export function GetTemplatePermission(userId, templateId, fields) {
//   return request({
//     url: `/users/${userId}/templates/${templateId}/permissions?fields=${fields || ''}`,
//     method: 'get'
//   })
// }

// 获取该用户对于该单据的权限属性
export function GetTemplatePermission(userId, templateId, recordId, fields) {
  if (recordId) {
    return request({
      url: `/users/${userId}/templates/${templateId}/permissions?reportId=${recordId}&fields=${fields || ''}`,
      method: 'get'
    })
  } else {
    return request({
      url: `/users/${userId}/templates/${templateId}/permissions?fields=${fields || ''}`,
      method: 'get'
    })
  }
}

// 打开模板Json文件
export function GetTemplateJsonFile(templateId, params) {
  return request({
    url: `/templates/${templateId}/jsonfile`,
    method: 'get',
    params
  })
}

// 获取模板数据表信息
export function GetTemplateDataSheets(templateId) {
  return request({
    url: `/templates/${templateId}/structure`,
    method: 'get'
  })
}

// 获取关联填报填值信息
export function GetTemplateConnectInfo(connectInfo) {
  const params = {
    connectId: connectInfo.connectId
  }
  return request({
    url: `/templates/${connectInfo.templateId}/forms/${connectInfo.recordId}/templateconnect`,
    method: 'get',
    params
  })
}

// 获取关联填报填值信息
export function GetTemplateConditions(templateId) {
  return request({
    url: `/templates/${templateId}/conditions`,
    method: 'get'
  })
}

export function GetChartsInfo(userId, templateId) {
  return request({
    url: `/users/${userId}/templates/${templateId}/charts`
  })
}

export function GetChartsParamInfo(userId, templateId) {
  return request({
    url: `/users/${userId}/templates/${templateId}/chartparam`
  })
}

export function GetChartsData(templateId, chartId, data) {
  return request({
    url: `/charts/${chartId}/template/${templateId}/output`,
    method: 'post',
    data
  })
}
// 获取模板绑定的图表
export function getTemplateCharts(id) {
  return request({
    url: `/templates/${id}/charts`,
    method: 'get'
  })
}
// 输出模板上所有绑定的图表参数信息
export function getTemplateChartsParams(id) {
  return request({
    url: `/templates/${id}/chartinput`,
    method: 'get'
  })
}
// 获取模板图表数据
export function getTemplateChartOutPut(id, templateid, data) {
  return request({
    url: `/charts/${id}/template/${templateid}/output`,
    method: 'post',
    data
  })
}
// 返回表单的状态信息，目前仅返回表单锁信息，后续可能会有追加
export function getTemplateState(templateId, formId) {
  return request({
    url: `/templates/${templateId}/forms/${formId}/state`,
    method: 'get'
  })
}

export function getConnectInfo(connectId) {
  return request({
    url: `/templateconnects/${connectId}`,
    method: 'get'
  })
}

export function getConnectInvokeInfo(connectId, recordId) {
  return request({
    url: `/templateconnects/${connectId}/invoke?recordId=${recordId}`,
    method: 'post'
  })
}

export function getLinkInfo(linkId) {
  return request({
    url: `/templatelinks/${linkId}`,
    method: 'get'
  })
}

export function getUserActionInfo(templateId, userId) {
  return request({
    url: `/users/${userId}/templates/${templateId}/actions`,
    method: 'get'
  })
}

export function getActionParams(actionId) {
  return request({
    url: `/templateactions/${actionId}/param`,
    method: 'get'
  })
}

// 接受前端发出的表单操作通知
export function reportOperation(templateId, id, op) {
  const params = {
    op: op
  }
  return request({
    url: `/templates/${templateId}/forms/${id || -1}/operation`,
    method: 'post',
    params
  })
}
// 获取绑定的条码信息
export function getBindingBarCodeInfo(userId, templateId) {
  return request({
    url: `/users/${userId}/templates/${templateId}/codes`,
    method: 'get'
  })
}
// 获取条码关联填报参数
export function getBarCodeFormData(barCodeId, templateId, recordId) {
  return request({
    url: `/templatecodes/${barCodeId}/formdata`,
    method: 'get',
    params: {
      templateId: templateId,
      recordId: recordId
    }
  })
}
// 获取条码超链接内容
export function getBarCodeLink(barCodeId, templateId, recordId) {
  return request({
    url: `/templatecodes/${barCodeId}/forms`,
    method: 'post',
    params: {
      templateId: templateId,
      recordId: recordId
    }
  })
}
// 调用存储过程
export function getProcedureResult(templateId, queryId, data) {
  return request({
    url: `/storedprocedures/${queryId}/invoke?templateId=${templateId}`,
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data
  })
}
// 获取用户对目标的指定类型权限
export function getCurentPermission(id, params) {
  return request({
    url: `/users/${id}/permissions`,
    method: 'get',
    params,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}
// 获取用户可使用的样式公式
export function getFormatFormula(userId, templateId) {
  return request({
    url: `/users/${userId}/templates/${templateId}/formats`,
    method: 'get'
  })
}
export function getCurrentLabel(id) {
  return request({
    url: `/templatelabels/${id}`,
    method: 'get'
  })
}
// 获取模板邮件信息
export function getTemplateMailInfos(userId, templateId) {
  return request({
    url: `/users/${userId}/templates/${templateId}/emails`,
    method: 'get'
  })
}
// 获取发件内容
export function getTemplateMailContent(mailId, reportId, taskId, data = {}) {
  var params = {
    reportId: reportId,
    taskId: taskId
  }
  return request({
    url: `/templateemails/${mailId}/output`,
    method: 'post',
    params,
    data
  })
}
// 发送邮件
export function SendMail(mailId, data) {
  return request({
    url: `/email/${mailId}/invoke`,
    method: 'post',
    data
  })
}

// 获取表单基本属性
export function getAttribute(templateId, recordId) {
  return request({
    url: `/templates/${templateId}/forms/${recordId}/attribute`,
    method: 'get'
  })
}

// 接口合并1
export function prevdependence(templateId, params) {
  return request({
    url: `/templates/${templateId}/prevdependence`,
    method: 'get',
    params
  })
}

// 接口合并2
export function postdependence(templateId) {
  return request({
    url: `/templates/${templateId}/postdependence`,
    method: 'get'
  })
}

// 导出表单
export function exportReport(templateId, formData) {
  return request({
    url: `/templates/${templateId}/exportreport`,
    method: 'post',
    data: formData,
    responseType: 'blob'
  })
}

// 字体设置
// 获取字体列表
export function getFonts(params) {
  return request({
    url: `/fonts`,
    method: 'get',
    params
  })
}
